"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/libs/utils";

const labelVariants = cva(
  [
    "group-has-[:disabled]:cursor-not-allowed group-has-[:disabled]:text-coolgray-30",
    "has-[:disabled]:cursor-not-allowed has-[:disabled]:text-coolgray-30",
    "peer-disabled:cursor-not-allowed peer-disabled:text-coolgray-30",
  ],
  {
    variants: {
      variant: {
        text: "text-sm font-500 text-coolgray-60 ",
        select: "text-sm font-500 text-coolgray-60 ",
        checkbox: "text-base font-400 text-coolgray-90 ",
        radio: "text-base font-400 text-coolgray-90 ",
      },
    },
  },
);

export type LabelVariants = VariantProps<typeof labelVariants>;

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & LabelVariants
>(({ className, variant, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants({ variant }), className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
